import {
  SeatKind,
  TeamMemberStatus,
  TellentApps,
  TellentCurrentUser,
  TellentMember,
} from '@tellent/types';

import { MEMBER_LISTED_ONLY } from './types';

export function resolveMemberOrgGuid(user: TellentCurrentUser, appGuid: string) {
  const currentMember = user.members.find(member =>
    member.seats.find(seat => seat.appGuid === appGuid),
  )!;

  return currentMember?.orgGuid;
}

export function resolveMemberStatus(member: TellentMember): TeamMemberStatus {
  const { status, userGuid, invitation } = member;
  if (status === 'deactivated') return TeamMemberStatus.Deactivated;
  if (status === 'active' && !!userGuid) return TeamMemberStatus.Active;
  if (invitation && !invitation.accepted) return TeamMemberStatus.Invited;
  return TeamMemberStatus.NotInvited;
}

export function resolveMemberSeatCellText(
  member: TellentMember,
  apps: TellentApps[],
  kind: SeatKind,
): string {
  const memberSeat = member.seats.find(seat => seat.app.kind === kind);
  if (!memberSeat || memberSeat.status === 'deactivated') return '-';
  if (memberSeat?.role === null) return MEMBER_LISTED_ONLY;
  const app = apps.find(app => app.guid === memberSeat?.app.guid);

  return app?.status === 'active' ? memberSeat?.role?.name : '-';
}

export function resolveMemberFullName(member: Partial<TellentMember>) {
  const { firstName, lastName, email } = member;
  return firstName || lastName ? `${firstName || ''} ${lastName || ''}` : email;
}
